import QuestionHeader from './QuestionHeader';

export default QuestionHeader;
